import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useGestiondeReciclajeNfu from "../../../hooks/administrador/general/useGestiondeReciclajeNfu";
import "../../../styles/administrador.css";

const GestiondeReciclajeNfu = ({ year, mes, token, idAdministrador }) => {
  const chartRef = useRef(null);
  const data = useGestiondeReciclajeNfu(year, mes, token, idAdministrador);

  useEffect(() => {
    if (Array.isArray(data) && data.length && chartRef.current) {
      const chartDom = chartRef.current;
      let myChart = echarts.init(chartRef.current);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const colors = ["#e0f7e0", "#6ac5cb", "#45444e", "#a3b85b", "#3a6b74"];

      const meses = data.map((item) => item.mes.substring(0, 3).toUpperCase());

      const reencaucheData = data.map(
        (item) => parseFloat(item.Reencauche) || 0
      );
      const cantidadRecolectadaData = data.map(
        (item) => parseFloat(item.cantidad_recolectada) || 0
      );
      const metaEstablecidaData = data.map(
        (item) => parseFloat(item.meta_establecida) || 0
      );

      const metaTotalData = data.map((item) => {
        const metaOperativa = parseFloat(item.meta_operativa) || 0;
        const metaEstablecida = parseFloat(item.meta_establecida) || 0;
        const metaProyectada = parseFloat(item.meta_proyectada) || 0;
        return metaOperativa + metaEstablecida + metaProyectada;
      });

      const totalReencauche = reencaucheData.reduce((sum, val) => sum + val, 0);
      const totalRecolectado = cantidadRecolectadaData.reduce(
        (sum, val) => sum + val,
        0
      );
      const totalMetaEstablecida = metaEstablecidaData.reduce(
        (sum, val) => sum + val,
        0
      );
      const totalRealSum =
        totalRecolectado + totalReencauche + totalMetaEstablecida;

      const option = {
        color: colors,
        title: {
          text: "Cumplimiento a meta de reciclaje",
          left: "center",
          subtext: `GESTIÓN OPERATIVA: ${totalRecolectado.toLocaleString()} | REENCAUCHE: ${totalReencauche.toLocaleString()} |\n EXCEDENTE: ${totalMetaEstablecida.toLocaleString()} | GESTIÓN TOTAL: ${totalRealSum.toLocaleString()}`,
          subtextStyle: {
            fontWeight: "bold",
            fontSize: "12px",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "#fff",
          borderColor: "#ccc",
          borderWidth: 1,
          textStyle: {
            fontSize: 8,
            color: "#333",
            fontFamily: "inherit",
          },
          confine: true,
          formatter: function (params) {
            let tooltip = `<span style="font-size:8px;">${params[0].axisValue}</span>\n`;
            params.forEach((param) => {
              tooltip += `${param.marker}${
                param.seriesName
              }: ${param.value.toLocaleString()}\n`;
            });
            return tooltip.replace(/\n/g, "<br/>");
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "15%",
          containLabel: true,
        },
        legend: {
          data: [
            "Reencauche",
            "Gestión Operativa",
            "Excedente",
            "Meta Proyectada",
          ],
          bottom: 0,
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true,
            },
            data: meses,
            axisLabel: {
              fontSize: 11,
              fontWeight: "bold",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            position: "left",
            axisLine: {
              show: true,
              lineStyle: {
                color: "black",
              },
            },
            axisLabel: {
              formatter: function (value) {
                if (value >= 1000000) return (value / 1000000).toFixed(1) + "M";
                if (value >= 1000) return (value / 1000).toFixed(0) + "k";
                return value;
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
              },
            },
          },
        ],
        series: [
          {
            name: "Reencauche",
            type: "bar",
            stack: "total",
            emphasis: {
              focus: "series",
            },
            data: reencaucheData,
            itemStyle: {
              color: colors[1],
            },
          },
          {
            name: "Gestión Operativa",
            type: "bar",
            stack: "total",
            emphasis: {
              focus: "series",
            },
            data: cantidadRecolectadaData,
            itemStyle: {
              color: colors[3],
            },
          },
          {
            name: "Excedente",
            type: "bar",
            stack: "total",
            emphasis: {
              focus: "series",
            },
            data: metaEstablecidaData,
            itemStyle: {
              color: colors[2],
            },
          },
          {
            name: "Meta Proyectada",
            type: "line",
            smooth: false,
            symbolSize: 6,
            lineStyle: {
              width: 3,
              type: "solid",
            },
            itemStyle: {
              color: "black",
            },
            data: metaTotalData,
          },
        ],
      };

      myChart.setOption(option);

      const updateChart = () => {
        myChart.resize();
      };

      window.addEventListener("resize", updateChart);

      return () => {
        window.removeEventListener("resize", updateChart);
        myChart.dispose();
      };
    }
  }, [data]);

  return <div className="grafica" ref={chartRef}></div>;
};

export default GestiondeReciclajeNfu;
